import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-of-logo',
  templateUrl: './of-logo.component.html',
  styleUrls: ['./of-logo.component.scss']
})
export class OfLogoComponent implements OnInit {

  constructor() { }

  public ngOnInit(): void {
  }

}
